// src/core/utils/partGroupUtils.js
import {getGroupItemList} from "../api/optionApis";

export const fetchPartGroupItems = async (vehicleId, groupInfoList) => {
  const fetchPromises = groupInfoList.map(({groupId, stepType}) =>
    getGroupItemList(vehicleId, stepType, groupId)
      .then(res => {
        if (res.data.result && res.data.message === "SUCCESS") {
          return {[groupId]: res.data.data.partGroupItems};
        }
        return {[groupId]: []};
      })
      .catch(err => {
        console.error(`Part group(${groupId}) request error :`, err);
        return {[groupId]: []};
      })
  );

  const results = await Promise.all(fetchPromises);
  return results.reduce((acc, current) => ({...acc, ...current}), {});
};
